import React, { Component } from 'react';
import PropTypes from 'prop-types';
import dateFormat from 'dateformat';
import { Link } from 'react-router-dom';

export default class CustomerOrdersList extends Component {
  renderOrders() {
    return this.props.orders.map((order) => {
      const timeMask = 'm/d/yy h:MM:ss TT Z';
      const firstFuelOrder = order.fuelOrders.length > 0 ? order.fuelOrders[0] : null;
      return (
        <span key={order.id} className="order-item">
          {/* <div className="order-number"> */}
          <div className="report-col-9">
            <Link to={{ pathname: `/orders/${order.id}`, state: { orderId: order.id }}}>
              #{order.orderNumber}
            </Link>
          </div>
          {/* <div className="invoice-number"> */}
          <div className="report-col-9">
            {order.invoiceNumber ? order.invoiceNumber : 'N/A'}
          </div>
          {/* <div className="expected-fulfill-date"> */}
          <div className="report-col-9">
            {order.closedAt ? dateFormat(order.closedAt, timeMask) : 'N/A' }
          </div>
          {/* <div className="fulfilled-at"> */}
          <div className="report-col-9">
            {dateFormat(order.fulfilledAt, timeMask) }
          </div>
          {/* <div className="customer-name"> */}
          <div className="report-col-9">
            {order.customerName ? order.customerName : 'N/A' }
          </div>
          {/* <div className="fuel-type-name"> */}
          <div className="report-col-9">
            {firstFuelOrder ? firstFuelOrder.fuelType.name : 'N/A' }
          </div>
          {/* <div className="quantity"> */}
          <div className="report-col-9">
            {firstFuelOrder ? parseFloat(firstFuelOrder.totalQuantityAdded).toFixed(1) : 'N/A' }
          </div>
          {/* <div className="oil-type-name"> */}
          <div className="report-col-9">
            {order.oilOrder ? order.oilOrder.oilType.name : 'N/A' }
          </div>
          {/* <div className="quantity"> */}
          <div className="report-col-9">
            {order.oilOrder ? parseFloat(order.oilOrder.quantity).toFixed(1) : 'N/A'}
          </div>
          <div className="clear" />
        </span>
      );
    });
  }

  renderOrderGroupHeadings() {
    return (
      <div className="report-item-headings">
        <div className="report-col-9">Order #</div>
        <div className="report-col-9">Invoice # </div>
        <div className="report-col-9">Closed Date</div>
        <div className="report-col-9">Fulfilled</div>
        <div className="report-col-9">Customer</div>
        <div className="report-col-9">Fuel Type</div>
        <div className="report-col-9">Fuel Quantity</div>
        <div className="report-col-9">Oil Type</div>
        <div className="report-col-9">Oil Quantity</div>
        <div className="clear" />
      </div>
    );
  }

  render() {
    return (
      <span>
        <h4>Orders</h4>
        {this.renderOrderGroupHeadings()}
        <article className="order-item">
          {this.renderOrders()}
        </article>
      </span>
    );
  }
}

CustomerOrdersList.propTypes = {
  orders: PropTypes.array.isRequired,
};




// WEBPACK FOOTER //
// ./src/Containers/Reports/CustomerOrders/CustomerOrdersList.js